import _ from 'lodash';
import { lsApiService } from 'ls-vue-common';
// eslint-disable-next-line import/no-cycle
import router from '@/router';
// eslint-disable-next-line import/no-cycle
import lsOrderService from '@/services/order/order.service';
import {
    CUSTOMER_LEADS__MUTATE_FORM,
    CUSTOMER_LEADS__MUTATE_LOADING_STATUS,
    CUSTOMER_LEADS__GET_DETAILS,
    CUSTOMER_LEADS__SAVE_FORM_DATA,
    CUSTOMER_LEADS__SUBMIT,
    ERROR__SET_ERROR,
} from '../types';

const createInitialState = () => ({
    form: {},
    loadingStatus: {
        isLoading: false,
        isUpdating: false,
    },
});

export const mutations = {
    [CUSTOMER_LEADS__MUTATE_FORM](state, payload) {
        _.assign(state.form, payload);
    },
    [CUSTOMER_LEADS__MUTATE_LOADING_STATUS](state, payload) {
        _.assign(state.loadingStatus, payload);
    },
};

export const actions = {
    [CUSTOMER_LEADS__GET_DETAILS]({ commit, dispatch }, { id }) {
        commit(CUSTOMER_LEADS__MUTATE_LOADING_STATUS, {
            isLoading: true,
        });

        return lsApiService
            .request({
                route: `/orders/${id}/customer-leads/details`,
            })
            .then(({ data }) => {
                const form = {};

                form.serviceOptions = _.map(data.services, (service) => ({
                    ...service,
                    selected: false,
                }));

                form.services = [];

                form.locations = [];
                form.notes = '';

                form.budgetOptions = _.map(
                    data.budgets,
                    // eslint-disable-next-line camelcase
                    ({ budget_low, budget_high }, idx) => {
                        const low = _.replace(budget_low, /\B(?=(\d{3})+(?!\d))/g, ',');
                        const high = _.replace(budget_high, /\B(?=(\d{3})+(?!\d))/g, ',');
                        let label = `$${low} – $${high}`;

                        if (idx === 0) {
                            label = `Up to $${high}`;
                        }

                        return {
                            label,
                            value: { budget_low, budget_high },
                        };
                    }
                );

                form.budgetOptions.push({
                    label: 'Prefer not to say',
                    value: {
                        budget_low: null,
                        budget_high: null,
                    },
                });

                form.budget = null;

                form.stageOptions = _.map(data.stages, ({ display, value }) => ({
                    label: display,
                    value,
                }));

                form.stage = null;

                form.showAll = false;

                commit(CUSTOMER_LEADS__MUTATE_FORM, form);
            })
            .catch((error) => {
                dispatch(ERROR__SET_ERROR, error);
            })
            .finally(() => {
                commit(CUSTOMER_LEADS__MUTATE_LOADING_STATUS, {
                    isLoading: false,
                });
            });
    },

    [CUSTOMER_LEADS__SAVE_FORM_DATA]({ commit }, formData) {
        commit(CUSTOMER_LEADS__MUTATE_FORM, formData);
    },

    [CUSTOMER_LEADS__SUBMIT]({ commit, state, rootState, dispatch }) {
        commit(CUSTOMER_LEADS__MUTATE_LOADING_STATUS, {
            isUpdating: true,
        });

        const { form } = state;

        let payload = {
            services: _.map(form.services, (id) => ({ id })),
            ...rootState.contactInfo,
        };

        if (!rootState.order.flags['customer.signUp.landscapingLeads_V2']) {
            payload = {
                ...payload,
                notes: form.notes,
                ...form.budget,
                ..._.reduce(
                    form.locations,
                    (result, value) => {
                        // eslint-disable-next-line no-param-reassign
                        result[value] = true;
                        return result;
                    },
                    {}
                ),
                stage: form.stage,
            };
        }

        return lsApiService
            .request({
                method: 'POST',
                route: `/orders/${rootState.order.id}/customer-leads`,
                payload,
            })
            .then(({ data }) => {
                lsOrderService.clearStoredOrderData();
                if (data.success && data.authtoken) {
                    window.location.href = `${process.env.VUE_APP_CUSTOMER_BASE_URL}?auth=${data.authtoken}`;
                } else {
                    router.push({ path: '/single-signup/form/thanks' });
                }
            })
            .catch((error) => {
                dispatch(ERROR__SET_ERROR, error);
            })
            .finally(() => {
                commit(CUSTOMER_LEADS__MUTATE_LOADING_STATUS, {
                    isUpdating: false,
                });
            });
    },
};

export const customerLeads = {
    state: createInitialState,
    mutations,
    actions,
};
